<div class="simple-table__location-search">
    <input [formControl]="searchControl" class="simple-table__filter--search" [placeholder]="dynamicPlaceholder"
        [attr.aria-label]="translateData?.aria_search_organization || 'Search organization'" />
</div>


@if (hasResults()) {
<div class="simple-table__location-results">
    <div class="simple-table__location-item">
        <label class="simple-table__label-checkbox simple-table__label-checkbox--all">
            <input #selectAllBox type="checkbox" [checked]="isAllSelected()"
                (change)="onToggleSelectAll(selectAllBox.checked)" />
            {{ translateData?.select_all || '(Select All)' }}
        </label>
    </div>

    @for (categoryKey of getCategoryKeys(); track trackByFn($index, categoryKey)) {
    <div class="simple-table__category-group">
        <div class="simple-table__category-header">
            {{ categoryKey }}
        </div>

        @for (item of searchResults[categoryKey]; track trackByFn($index, item)) {
        <div class="simple-table__location-item">
            <label class="simple-table__label-checkbox">
                <input type="checkbox" [id]="idFor('org', item.ORG_sub)" [checked]="isSelected(item)"
                    (change)="onCheckboxChange($event.target.checked, item.ORG_sub)" />
                {{ item.Organization_subcategory || item.ORG_sub }}
            </label>
        </div>
        }
    </div>
    }
</div>
} @else {
<div class="simple-table__location-results">
    <span class="simple-table__no-results">No results found.</span>
</div>
}